const config = {
  env: import.meta.env.VITE_ENV || 'local',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || `${window.location.protocol}//${window.location.hostname}:8000`,
};

export default config;
